export class BrandsOverview
{
  constructor(brandsOverviewNode)
  {
    this.brandsOverview = brandsOverviewNode;

    if(!this.brandsOverview){
      return;
    }

    this.sliders = this.brandsOverview.querySelectorAll('.brands-overview__slider');

    this.initSlidingScrollWatch();
  }

  initSlidingScrollWatch()
  {
    this.slide();
    window.addEventListener('scroll', () => {
      this.slide();
    });
  }

  slide()
  {
    const rect = this.brandsOverview.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const start = rect.top - windowHeight;
    const end = rect.bottom;
    const total = end - start;

    const scrolled = window.scrollY + windowHeight - this.brandsOverview.offsetTop;
    const progress = Math.min(Math.max(scrolled / total, 0), 1);

    const maxTranslate = 400;
    const translateX = -progress * maxTranslate;

    this.sliders[0].style.transform = `translateX(calc(-50% + ${translateX}px))`;
    this.sliders[1].style.transform = `translateX(calc(-50% + ${translateX * -1}px))`;
  }

}
